import React from "react";
import { Link } from "react-router-dom";


function StudentFooter() {
  const getFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // Jan = 0

    if (month >= 4) {
      return `${year} – ${year + 1}`;
    } else {
      return `${year - 1} – ${year}`;
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="py-3 text-center">
            © {getFinancialYear()} The Pilot Guide.
          </div>
        </div>
      </div>

      <Link
        to="#"
        id="back2Top"
        className="top-scroll"
        title="Back to top"
      >
        <i className="ti-arrow-up"></i>
      </Link>
    </>
  );
}

export default StudentFooter;
